import { formatTimeStampToDateString } from '../../../../util/DateUtil';
export var DeliveryUnit;
(function (DeliveryUnit) {
    DeliveryUnit["HOURS"] = "H";
    DeliveryUnit["WEEKS"] = "W";
    DeliveryUnit["DAYS"] = "D";
})(DeliveryUnit || (DeliveryUnit = {}));
export const filterScheduleEntries = (scheduleEntries) => {
    const COUNT_DAYS = 7;
    const CURRENT_DATE = new Date(Date.now()).getDate();
    const indexCurrentDate = scheduleEntries.findIndex(schedule => new Date(schedule.date).getDate() === CURRENT_DATE);
    return [...scheduleEntries].splice(indexCurrentDate, COUNT_DAYS);
};
export const getDeliveryPromise = (store, t) => {
    let term = '';
    const singleDelivery = store.deliveryFrom === store.deliveryTo && store.deliveryTo === 1;
    switch (store.deliveryUnit) {
        case DeliveryUnit.HOURS:
            term = t(singleDelivery ? 'store:store.check.hour' : 'store:store.check.hours');
            break;
        case DeliveryUnit.WEEKS:
            term = t(singleDelivery ? 'store:store.check.week' : 'store:store.check.weeks');
            break;
        case DeliveryUnit.DAYS:
            term = t(singleDelivery ? 'store:store.check.day' : 'store:store.check.days');
            break;
        default:
            break;
    }
    if (store.deliveryFrom === store.deliveryTo) {
        return `${store.deliveryTo} ${term}`;
    }
    return `${store.deliveryFrom}-${store.deliveryTo} ${term}`;
};
export const formatDate = (date, locale, format) => formatTimeStampToDateString(new Date(date).getTime(), locale, format);
export const generateUrl = (store, location) => `https://www.openstreetmap.org/directions?engine=fossgis_osrm_car&route=${location.lat}%2C${location.lng}
     %3B${store.latitude}%2C${store.longitude}`;
